import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {CountdownComposer} from "./countdown.composer";
import styles from "./countdown.module.scss"
import classNames from "classnames";

export class CountdownProps extends BaseProps {
}

export const Countdown = CountdownComposer(({gameTimeText, className, isSmallView}: CountdownProps) => {
  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <div className={className}>
        {gameTimeText}
      </div>
    </div>
  );
});
